/**
 * Latest evergreen browsers define these API's globally.
 * Add the constructors to `fetch` for a consistent cross-platform experience.
 * Technically client-side only code could directly use these API's. Code that
 * is used both client and server-side will benefit from consistency.
 */

function fetch(...args) {
  return window.fetch(...args);
}

fetch.Headers = window.Headers;
fetch.Request = window.Request;
fetch.Response = window.Response;
fetch.AbortController = window.AbortController;

// Wrapper to read whatever is assigned or monkey-patched on window.fetch at runtime
module.exports = fetch;
